import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { refreshCsrf } from './api/index.js';
import router from './router/index.js';
import App from './App.vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

refreshCsrf();

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');
